import { render, staticRenderFns } from "./BlogFeed.vue?vue&type=template&id=6f1d30a1"
import script from "./BlogFeed.vue?vue&type=script&lang=js"
export * from "./BlogFeed.vue?vue&type=script&lang=js"
import style0 from "./BlogFeed.vue?vue&type=style&index=0&id=6f1d30a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports